// extracted by mini-css-extract-plugin
export default {"container":"Car_container__ySUYi","name":"Car_name__INssA","subtitle":"Car_subtitle__lM1q6","price":"Car_price__zdkbg","imgContainer":"Car_imgContainer__m9R4U"};